import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

export default class DashboardServices {
	getEtapas () {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/etapas`, {
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getProcedimentosLista (dataInicio, filtros = {}) {
		return new Promise((resolve, reject) => {
			const params = { dataInicio };
			if (filtros.formaturaDe) params.formaturaDe = filtros.formaturaDe;
			if (filtros.formaturaAte) params.formaturaAte = filtros.formaturaAte;
			if (filtros.designer) params.designer = filtros.designer;
			axios.get(`${REQUEST_URL}/dashboard/procedimentos-lista`, {
				params,
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getProcedimentos (dataInicio, filtros = {}) {
		return new Promise((resolve, reject) => {
			const params = { dataInicio };
			if (filtros.formaturaDe) params.formaturaDe = filtros.formaturaDe;
			if (filtros.formaturaAte) params.formaturaAte = filtros.formaturaAte;
			if (filtros.designer) params.designer = filtros.designer;
			axios.get(`${REQUEST_URL}/dashboard/procedimentos`, {
				params,
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getDetalheProcedimento (proc, dataInicio, filtros = {}) {
		return new Promise((resolve, reject) => {
			const params = { proc, dataInicio };
			if (filtros.formaturaDe) params.formaturaDe = filtros.formaturaDe;
			if (filtros.formaturaAte) params.formaturaAte = filtros.formaturaAte;
			if (filtros.designer) params.designer = filtros.designer;
			axios.get(`${REQUEST_URL}/dashboard/procedimento/detalhe`, {
				params,
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getContratoTimeline (codigo) {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/contrato/timeline`, {
				params: { codigo },
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getComentarios (id_acao, id_contrato) {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/procedimento/comentarios`, {
				params: { id_acao, id_contrato },
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	buscarContrato (contrato) {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/buscar-contrato`, {
				params: { contrato },
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getDesigners () {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/designers`, {
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getProcedimentosMensal (ano, designer) {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/procedimentos-mensal`, {
				params: { ano, designer },
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getDetalheProcedimentoMensal (ano, mes, tipo, status, designer) {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/procedimentos-mensal/detalhe`, {
				params: { ano, mes, tipo, status, designer },
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getCronogramaSemanal (dataInicio, designer) {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/dashboard/cronograma-semanal`, {
				params: { dataInicio, designer },
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	salvarComentario (id_acao, id_contrato, comentario, usuario) {
		return new Promise((resolve, reject) => {
			axios.post(`${REQUEST_URL}/dashboard/procedimento/comentarios`, {
				id_acao, id_contrato, comentario, usuario
			}, {
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/services/dashboard.js